<ng-container *ngIf="branchName">
     <span *ngIf="isDividerRequired" class="headerDivider"></span>
    <div class="branchNameWrapper">
        <span  class="fontSize11">{{branchHeader}}</span>
        <div class="branchName">
            <span *ngIf="isBranchEditable" (click)="branchChange()">{{branchName}}</span>
            <span *ngIf="!isBranchEditable">{{branchName}}</span>
            <span *ngIf="isBranchEditable" class="arrow down"></span>
        </div>
    </div>
</ng-container>